(function () {
  // --- All UTC offsets we want to display ---
  const ALL_OFFSETS = [
    "-12:00", "-11:00", "-10:00", "-09:30", "-09:00", "-08:00", "-07:00", 
    "-06:00", "-05:00", "-04:30", "-04:00", "-03:30", "-03:00", "-02:00", 
    "-01:00", "+00:00", "+01:00", "+02:00", "+03:00", "+03:30", "+04:00", 
    "+04:30", "+05:00", "+05:30", "+05:45", "+06:00", "+06:30", "+07:00", 
    "+08:00", "+08:45", "+09:00", "+09:30", "+10:00", "+10:30", "+11:00", 
    "+12:00", "+12:45", "+13:00", "+14:00"
  ];

  // --- Helpers ---
  function findSelect() {
    return (
      document.getElementById("Time Zone-0-0") ||
      document.querySelector('select[name="properties[ Time Zone ]"]') ||
      document.querySelector('select[name="properties[Time Zone]"]') ||
      Array.from(document.querySelectorAll("select")).find(sel =>
        Array.from(sel.options || []).some(o => /^UTC[+\-−±]/.test((o.value || o.textContent || "").trim()))
      ) || null
    );
  }

  function parseUtcOffset(offsetStr) {
    // offsetStr like "+05:30" or "-08:00"
    const sign = offsetStr[0] === "-" ? -1 : 1;
    const [hh, mm] = offsetStr.slice(1).split(":").map(Number);
    return sign * (hh * 60 + mm);
  }

function getTimeAtOffset(date, offsetMinutes) {
  // Get current UTC time in minutes
  const utcHours = date.getUTCHours();
  const utcMinutes = date.getUTCMinutes();
  const utcTotalMinutes = utcHours * 60 + utcMinutes;
  
  // Add the offset
  let totalMinutes = utcTotalMinutes + offsetMinutes;
  
  // Handle day wrapping (keep within 0-1439 minutes)
  totalMinutes = ((totalMinutes % 1440) + 1440) % 1440;
  
  // Convert back to hours and minutes
  let hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  
  // Format as 12-hour time
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12;
  
  return `${hours}:${String(minutes).padStart(2, "0")}${ampm}`;
}

  function ensureLocalAndSeparator(selectEl) {
    let localOpt = selectEl.querySelector('option[data-local-tz="1"]');
    let sepOpt = selectEl.querySelector('option[data-tz-sep="1"]');

    if (!localOpt) {
      localOpt = document.createElement("option");
      localOpt.dataset.localTz = "1";
      const first = selectEl.options[0];
      const insertIdx = (first && (first.disabled || !first.value)) ? 1 : 0;
      selectEl.insertBefore(localOpt, selectEl.options[insertIdx] || null);
    }
    if (!sepOpt) {
      sepOpt = document.createElement("option");
      sepOpt.dataset.tzSep = "1";
      sepOpt.disabled = true;
      sepOpt.textContent = "────────────────────────";
      const i = Array.from(selectEl.options).indexOf(localOpt);
      selectEl.insertBefore(sepOpt, selectEl.options[i + 1] || null);
    }
    return { localOpt, sepOpt };
  }

  // --- Main ---
  function start() {
    const select = findSelect();
    if (!select) return false;

    function updateAll() {
      const now = new Date();

      // Local timezone (top)
      const { localOpt } = ensureLocalAndSeparator(select);
      const localOffsetMinutes = -now.getTimezoneOffset();
      const localSign = localOffsetMinutes >= 0 ? "+" : "-";
      const localAbs = Math.abs(localOffsetMinutes);
      const localHH = String(Math.floor(localAbs / 60)).padStart(2, "0");
      const localMM = String(localAbs % 60).padStart(2, "0");
      const localOffsetStr = `UTC${localSign}${localHH}:${localMM}`;
      const localTime = getTimeAtOffset(now, localOffsetMinutes);
      
      localOpt.value = localOffsetStr;
      localOpt.textContent = `${localTime} - ${localOffsetStr} (Local)`;

      // Clear existing offset options (keep local + separator + any disabled)
      const toRemove = Array.from(select.options).filter(o => 
        o && !o.dataset.localTz && !o.dataset.tzSep && !(o.disabled && !o.value)
      );
      toRemove.forEach(o => o.remove());

      // Add all UTC offset options
      ALL_OFFSETS.forEach(offsetStr => {
        const fullOffset = `UTC${offsetStr}`;
        const offsetMinutes = parseUtcOffset(offsetStr);
        const time = getTimeAtOffset(now, offsetMinutes);
        
        const option = document.createElement("option");
        option.value = fullOffset;
        option.textContent = `${time} - ${fullOffset}`;
        select.appendChild(option);
      });
    }

    updateAll();
    if (!select.dataset.tzTimerSet) {
      select.dataset.tzTimerSet = "1";
      setInterval(updateAll, 60000);
    }
    return true;
  }

  if (!start()) {
    const obs = new MutationObserver(() => { if (start()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 20000);
  }
})();